module.exports = __webpack_public_path__ + "img/poweredby2.371ebbcd.png";